import React from "react";
import { IconButton} from "../../components";
import { withStyles, Typography, FormControl, InputLabel, Input, InputAdornment } from "@material-ui/core";
import  Clear from "@material-ui/icons/Clear";
import  Check  from "@material-ui/icons/Check";
import PropTypes from "prop-types";
import cx from "classnames";
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

import { defaultFont } from "../../assets/jss/material-dashboard-react.jsx";

//import { CustomInput, IconButton as SearchButton } from "../../components";

import customInputStyle from "../../assets/jss/material-dashboard-react/customInputStyle";

class AddInput extends React.Component {
    constructor(props, context){
        super(props.context)
    }
  state = {
    open: false,
    password: '',
    showPassword: false,
  };

  handleChange = prop => event => {
    this.setState({ [prop]: event.target.value });
  };

  handleMouseDownPassword = event => {
    event.preventDefault();
  };

  handleClickShowPassword = () => {
    this.setState({ showPassword: !this.state.showPassword });
  };

  handleClick = () => {
    this.setState({ open: !this.state.open });
  };

  handleClose = () => {
    this.setState({ open: false });
  };
  render( ...props ) {
    if(!this.props.ispasschange){
        return null;
      }
    const { logout } = this.props;
    const { open,showPassword } = this.state;
    const {
        classes,
        formControlProps,
        labelText,
        id,
        labelProps,
        inputProps,
        error,
        success
      } = this.props;
      
  const labelClasses = cx({
    [" " + classes.labelRootError]: error,
    [" " + classes.labelRootSuccess]: success && !error
  });
  const underlineClasses = cx({
    [classes.underlineError]: error,
    [classes.underlineSuccess]: success && !error,
    [classes.underline]: true
  });
  const marginTop = cx({
    [classes.marginTop]: labelText === undefined
  });
    return (
        <FormControl onClick={this.props.onClick}
        {...formControlProps}
         className={formControlProps.className + " " + classes.formControl}
      >
                 <Typography style={styles.label}>
           {labelText}
        </Typography>
        {/* {labelText !== undefined ? (
          <InputLabel
             className={classes.labelRoot + labelClasses}
            htmlFor={id}
            {...labelProps}
          >
            {labelText}
          </InputLabel>
        ) : null} */}
        <Input
          //value={this.state.password}
          onChange={this.handleChange('password')}
          type={this.state.showPassword ? 'text' : 'password'}
          classes={{
            root: marginTop,
            disabled: classes.disabled,
            underline: underlineClasses,
          }}
          id={id}
          {...inputProps}
          endAdornment={
              <InputAdornment position="end">
                <IconButton
                  color="simple"
                  aria-label="Toggle password visibility"
                  onClick={this.handleClickShowPassword}
                  onMouseDown={this.handleMouseDownPassword}
                >
                  {this.state.showPassword ? <VisibilityOff style={styles.iconColor}/> : <Visibility style={styles.iconColor} />}
                </IconButton>
              </InputAdornment>
            }
        />
        {this.props.error ? <Typography style={styles.errorColor}>{this.props.error}</Typography> : null}
        {/* {error ? (
          <Clear className={classes.feedback + " " + classes.labelRootError} />
        ) : success ? (
          <Check className={classes.feedback + " " + classes.labelRootSuccess} />
        ) : null} */}
      </FormControl>
    );
  }
}

AddInput.propTypes = {
    classes: PropTypes.object.isRequired,
    labelText: PropTypes.node,
    labelProps: PropTypes.object,
    id: PropTypes.string,
    inputProps: PropTypes.object,
    formControlProps: PropTypes.object,
    error: PropTypes.string,
    success: PropTypes.bool
  };
  
  const styles = {
    disabled: {
        "&:before": {
          backgroundColor: "transparent !important"
        }
      },
      label: {
        ...defaultFont,
        color: "#AAAAAA",
        fontWeight: "400",
        fontSize: "14px",
        lineHeight: "1.42857",
        //marginTop: "16px"
      },
      marginTop: {
        marginTop: "16px"
      },
      formControl: {
        paddingBottom: "10px",
        margin: "27px 0 0 0",
        position: "relative"
      },
      iconColor: {
        color:"black"
    },
    errorColor: {
      color:"#f44336",
    },


};
export default withStyles(customInputStyle)(AddInput);



// WEBPACK FOOTER //
// ./src/components/AddInput/AddInput.jsx